module.exports = __webpack_public_path__ + "img/loading.94247823.svg";